/**
 * Get background color class based on urgency
 */
export const getUrgencyBackgroundColor = (urgency: string): string => {
  switch (urgency.toLowerCase()) {
    case "critical":
      return "bg-red-100";
    case "high":
      return "bg-orange-100";
    case "medium":
      return "bg-blue-100";
    case "low":
    default:
      return "bg-green-100";
  }
};

/**
 * Get text color class based on urgency
 */
export const getUrgencyTextColor = (urgency: string): string => {
  switch (urgency.toLowerCase()) {
    case "critical":
      return "text-red-600";
    case "high":
      return "text-orange-600";
    case "medium":
      return "text-blue-600";
    case "low":
    default:
      return "text-green-600";
  }
};

/**
 * Get numeric order value for urgency level (lower = more urgent)
 * Used for sorting: critical (0) > high (1) > medium (2) > low (3)
 */
export const getUrgencyOrder = (urgency: string): number => {
  switch (urgency.toLowerCase()) {
    case "critical":
      return 0;
    case "high":
      return 1;
    case "medium":
      return 2;
    case "low":
    default:
      return 3;
  }
};
